import { alpha, darken, lighten, styled } from '@mui/material';

export const Table = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
});

export const TableRow = styled('div')(({ theme }) => ({
  flex: '1 1 0',
  display: 'flex',
  paddingLeft: '6px',
  paddingRight: '6px',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  borderBottom: `1px solid
    ${
      theme.palette.mode === 'light'
        ? lighten(alpha(theme.palette.divider, 1), 0.88)
        : darken(alpha(theme.palette.divider, 1), 0.68)
    }`,
}));

export const TableHeaderRow = styled(TableRow)({});

export const TableBodyRow = styled(TableRow)(({ theme }) => ({
  flexDirection: 'row',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  [`&:hover`]: {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const TableCells = styled('div')({
  flex: '1 1 0',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  flexWrap: 'wrap',
});

export const TableCell = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
});

export const TableHeaderCell = styled(TableCell)(({ theme }) => ({
  ...theme.typography.body2,

  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.text.primary,
}));

export const TableBodyCell = styled(TableCell)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.primary,
}));

// needed the inner div to ensure proper flex-distribution with the gap
export const TableCellInner = styled('div')({
  flex: '1 1 0',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '6px 6px',
});

export const ActionCell = styled(TableCell)({
  flex: 'none',
  width: 50,
  padding: '6px 6px',
});
